import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { register } from './serviceWorker';

createRoot(document.getElementById('root')).render(<App />);
register();
